import React, { useState, useCallback } from 'react';

import EditorComponent from '~/common/editor/_Editor';
import Controls from './Controls';

export default function Editor(props) {
    const { template, isInAction, creativeName, videosCount, saved, hasCorruptionReason, setSaveStatus } = props;

    const [state, setState] = useState({
        showDiscardModal: false,
        showPublishModal: false,
        showSaveAsTemplateModal: false,
        showSaveAsVideoModal: false,
        showSaveAsVideoNotAcceptableErrorModal: false,
        creativeVersionName: '',
    });

    const save = useCallback(
        (creativeModel, exportIntegrations, exportConfigurationIds, approvalEnabled, reviewers, silent) => {
            props.handleOnSave(
                creativeModel,
                exportIntegrations,
                exportConfigurationIds,
                approvalEnabled,
                reviewers,
                silent,
            );
        },
        [props.handleOnSave],
    );

    const discard = useCallback(() => {
        setState((prev) => ({ ...prev, showDiscardModal: false }));
        props.handleOnDiscard();
    }, [props.handleOnDiscard]);

    const publish = useCallback(
        (creativeModel, exportIntegrations, exportConfigurationIds, approvalEnabled, reviewers) => {
            props.handleOnPublish(
                creativeModel,
                exportIntegrations,
                exportConfigurationIds,
                approvalEnabled,
                reviewers,
            );
            setState((prev) => ({ ...prev, creativeVersionName: '' }));
        },
        [props.handleOnPublish],
    );

    const saveAsTemplate = useCallback(
        (tmplData) => {
            props.saveAsTemplate(tmplData);
            setState((prev) => ({ ...prev, showSaveAsTemplateModal: false }));
        },
        [props.saveAsTemplate],
    );

    const saveAsVideoModal = useCallback(
        () => (name) => {
            props.saveAsVideo(name, (errorPayload) => {
                if (errorPayload?.appErrorCode === 11001) {
                    setState((prev) => ({ ...prev, showSaveAsVideoNotAcceptableErrorModal: true }));
                }
            });
            setState((prev) => ({ ...prev, showSaveAsVideoModal: false }));
        },
        [props.saveAsVideo],
    );

    const handleDiscardModal = useCallback((show) => {
        setState((prev) => ({ ...prev, showDiscardModal: show }));
    }, []);

    const handlePublishModal = useCallback((show) => {
        setState((prev) => ({ ...prev, showPublishModal: show }));
    }, []);

    const closePublishModal = useCallback(() => {
        setState((prev) => ({ ...prev, showPublishModal: false }));
    }, []);

    const handleSaveAsTemplateModal = useCallback((show) => {
        setState((prev) => ({ ...prev, showSaveAsTemplateModal: show }));
    }, []);

    const handleSaveAsVideoModal = useCallback((show) => {
        setState((prev) => ({ ...prev, showSaveAsVideoModal: show }));
    }, []);

    const closeSaveAsVideoNotAcceptableErrorModal = useCallback(() => {
        setState((prev) => ({ ...prev, showSaveAsVideoNotAcceptableErrorModal: false }));
    }, []);

    const handleNameChange = useCallback((value) => {
        setState((prev) => ({ ...prev, creativeVersionName: value }));
    }, []);

    if (!template) return <div />;

    const controlsProps = {
        template,
        saved,
        discard,
        handlePublishModal,
        handleDiscardModal,
        save,
        publish,
        handleNameChange,
        isInAction,
        videosCount,
        handleSaveAsVideoModal,
        closeSaveAsVideoNotAcceptableErrorModal,
        handleSaveAsTemplateModal,
        saveAsTemplate,
        saveAsVideoModal,
        creativeName,
        hasCorruptionReason,
        setSaveStatus,
        closePublishModal,
        ...state,
    };

    return (
        <EditorComponent key="spec_key" handleOnResize={() => null} {...props} controlsProps={controlsProps}>
            <Controls {...controlsProps} />
        </EditorComponent>
    );
}
